import React from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';

const VisualPreferenceQuestion = ({ question, selectedAnswers, onAnswerSelect, multiSelect }) => {
  const handleSelect = (optionId) => {
    if (multiSelect) {
      const newSelection = selectedAnswers?.includes(optionId)
        ? selectedAnswers?.filter(id => id !== optionId)
        : [...selectedAnswers, optionId];
      onAnswerSelect(newSelection);
    } else {
      onAnswerSelect(optionId);
    }
  };

  const isSelected = (optionId) => {
    return multiSelect ? selectedAnswers?.includes(optionId) : selectedAnswers === optionId;
  };

  return (
    <div className="space-y-4 md:space-y-6">
      <div className="space-y-2">
        <h2 className="text-xl md:text-2xl lg:text-3xl font-semibold text-foreground">
          {question?.text}
        </h2>
        <p className="text-sm md:text-base text-muted-foreground">
          {multiSelect 
            ? "Sélectionnez toutes les options qui vous intéressent" :"Choisissez l'option qui vous attire le plus"}
        </p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
        {question?.options?.map((option) => {
          const selected = isSelected(option?.id);

          return (
            <button
              key={option?.id}
              onClick={() => handleSelect(option?.id)}
              className={`
                group relative w-full rounded-xl overflow-hidden transition-smooth
                ${selected ? 'ring-4 ring-primary' : 'ring-2 ring-border hover:ring-primary/50'}
              `}
            >
              <div className="aspect-[4/3] w-full overflow-hidden">
                <Image
                  src={option?.image}
                  alt={option?.imageAlt}
                  className="w-full h-full object-cover group-hover:scale-105 transition-smooth"
                />
              </div>
              <div className={`
                absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent
                flex flex-col justify-end p-4 md:p-5
              `}>
                <div className="flex items-start justify-between gap-2">
                  <div className="flex-1 min-w-0">
                    <h3 className="text-base md:text-lg font-semibold text-white mb-1">
                      {option?.title}
                    </h3>
                    {option?.description && (
                      <p className="text-xs md:text-sm text-white/80 line-clamp-2">
                        {option?.description}
                      </p>
                    )}
                  </div>
                  <div className={`
                    flex-shrink-0 w-6 h-6 md:w-7 md:h-7 rounded-full border-2 flex items-center justify-center transition-smooth
                    ${selected ? 'border-primary bg-primary' : 'border-white bg-transparent'}
                  `}>
                    {selected && (
                      <Icon name="Check" size={14} color="#FFFFFF" />
                    )}
                  </div>
                </div>
              </div>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default VisualPreferenceQuestion;